import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { skillsStoreKey } from './skills.const';
import { getSkillsPath } from '../../constants/apiEndpoints';
import { formatErrorMessage } from '../../utils';
import { notificationAlert } from '../notifications';
import { ITechSkillsData } from '@types';

export const getSkills = createAsyncThunk(
  `${skillsStoreKey}/getSkills`,
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(getSkillsPath());
      return response.data as ITechSkillsData;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );
      throw new Error(err);
    }
  },
);
